import { Component, DestroyRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { API, SharedPlaybackScheduleDTO } from 'src/app/services/api/api';
import { SbLocalDateTime } from 'src/app/services/api/api-date-time';
import { ErrorService } from 'src/app/services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { DateTime } from 'luxon';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize, take } from 'rxjs/operators';

@Component({
  selector: 'sb-page-device-playback-schedule',
  templateUrl: './device-details-playback-schedule.component.html',
  styleUrls: ['./device-details-playback-schedule.component.scss'],
  standalone: false,
})
export class DeviceDetailsPlaybackScheduleComponent implements OnInit {
  deviceId: number;

  loading: boolean = true;

  sharedSchedules: SharedPlaybackScheduleDTO[] = [];

  debounceTimer: ReturnType<typeof setTimeout> = null;

  // tslint:disable-next-line:variable-name
  _from?: SbLocalDateTime;
  get from(): SbLocalDateTime {
    return this._from;
  }

  set from(val) {
    this._from = val;
  }

  // tslint:disable-next-line:variable-name
  _till?: SbLocalDateTime;
  get till(): SbLocalDateTime {
    return this._till;
  }

  set till(val) {
    this._till = val;
  }

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    public errorHandler: ErrorService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit() {
    this.activatedRoute.parent.params.subscribe(params => {
      this.deviceId = +params.deviceID;
      this.playlistRequestDebounced();
    });
  }

  playlistRequestDebounced() {
    this.loading = true;
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.playlistRequest();
    }, 500);
  }

  playlistRequest() {
    const defaultTime: SbLocalDateTime = new SbLocalDateTime(DateTime.now());
    this.api
      .ss_nm_Network_retrieveAllSharedPlaybackSchedules({
        from: this.from ? this.from : defaultTime,
        till: this.till ? this.till : defaultTime,
        screen: null,
        device: !isNaN(this.deviceId) ? [this.deviceId] : null,
        playerCull: null,
      })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (e: SharedPlaybackScheduleDTO[]) => {
          this.sharedSchedules = e;
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
  }

  handleDateChangeFrom(date: SbLocalDateTime) {
    this.from = date;
  }

  handleDateChangeTill(date: SbLocalDateTime) {
    this.till = date;
  }
}
